import { useState } from "react";
import { Button, Input } from "../../ui/ot";
import { useNavigate } from "react-router-dom";

// 依 航校圖書館網頁.docx：整合查詢 / 資料庫查詢 / 館藏書籍 / 試用資料庫
const TABS = [
  { key: "integrated", label: "整合查詢", placeholder: "請輸入關鍵字(檢索內容含電子及紙本資源)" },
  { key: "database", label: "資料庫查詢", placeholder: "查找電子書書名、期刊名稱、資料庫名稱" },
  { key: "collection", label: "館藏書籍", placeholder: "請輸入書名或期刊名之關鍵字" },
  { key: "trial", label: "試用資料庫", placeholder: "請輸入試用資料庫關鍵字" },
];

const SearchTabs = ({ propsNavigateSearchPath = "/library" }) => {
  const navigate = useNavigate();
  const [active, setActive] = useState(TABS[0].key);
  const [keyword, setKeyword] = useState("");
  const [error, setError] = useState("");
  const activeTab = TABS.find((t) => t.key === active) || TABS[0];

  const handleSearch = (e) => {
    e.preventDefault();
    if (!keyword.trim()) {
      setError("請輸入關鍵字");
      return;
    }
    setError("");
    // 導向 preview 版查詢頁，帶 tab → 依 tab 設定預設檢索範圍（原始 OPAC 頁不動）
    const params = new URLSearchParams({ search: keyword, tab: active });
    navigate(`/officialweb_preview/search?${params.toString()}`);
  };

  return (
    <form
      className="w-full bg-gray-50 rounded-lg shadow-md overflow-hidden"
      onSubmit={handleSearch}
    >
      {/* 四個查詢頁籤 */}
      <div className="flex flex-wrap border-b border-gray-200">
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => {
              setActive(t.key);
              setError("");
            }}
            className={`px-5 py-3 text-sm font-semibold transition ${
              active === t.key
                ? "bg-white text-blue-700 border-b-2 border-blue-600"
                : "text-gray-500 hover:text-blue-600"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* 關鍵字輸入 + 查詢鈕 */}
      <div className="flex w-full items-center gap-3 p-6">
        <div className="flex flex-col flex-1">
          <Input
            placeholder={activeTab.placeholder}
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            className={`pl-4 pr-4 py-2 text-base rounded-md border ${
              error ? "border-red-500" : "border-gray-300"
            } focus:border-blue-500 w-full shadow-sm transition`}
          />
        </div>
        <Button
          type="submit"
          onClick={handleSearch}
          className="h-10 px-6 rounded-md bg-gradient-to-r from-blue-500 to-blue-700 hover:from-blue-600 hover:to-blue-800 text-white text-sm font-semibold shadow-md transition-transform transform hover:scale-105 whitespace-nowrap"
        >
          查詢
        </Button>
      </div>

      {error && (
        <div className="px-6 pb-3 -mt-3 text-xs text-red-500">{error}</div>
      )}
    </form>
  );
};

export default SearchTabs;
